import { StockInfo } from '../StockInfo/StockInfo.component';
import React, { ComponentProps, FC, ReactNode } from 'react';
import classnames from 'classnames';

export enum StocksAccordionElementWidth {
  full = 'full-width',
  half = 'half-width',
}

type Props = Omit<ComponentProps<typeof StockInfo>, 'type'> & {
  type: StocksAccordionElementWidth;
  element?: ReactNode;
  unit?: string;
};

const StocksAccordionRowElement: FC<Props> = ({ element, type, unit, className, ...rest }) => {
  const rootClass = classnames(type, className);
  return (
    <StockInfo className={rootClass} type="accordion" unit={unit} {...rest}>
      {typeof element === 'undefined' ? '-' : element}
    </StockInfo>
  );
};

export { StocksAccordionRowElement };
